'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ar_EG = require('../locale/ar_EG');

var _ar_EG2 = _interopRequireDefault(_ar_EG);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _ar_EG2['default'];